import { useState } from "react";
import { Show, SignInButton, UserButton } from "@clerk/react";
import { Header } from "@/components/reels/Header";
import { SingleCard } from "@/components/reels/SingleCard";
import { BulkCard } from "@/components/reels/BulkCard";
import { SavedPanel } from "@/components/reels/SavedPanel";
import { HistoryPanel } from "@/components/reels/HistoryPanel";
import { CreatorsPanel } from "@/components/reels/CreatorsPanel";
import { Segment } from "@/components/reels/controls";

const MODES = [["single", "Single"], ["bulk", "Bulk"], ["creators", "Creators"], ["saved", "Saved"], ["history", "History"]];
const QUALITIES = [["original", "Original HD"], ["4k", "4K Upscale"]];

export default function Home() {
  const [mode, setMode] = useState("single");
  const [quality, setQuality] = useState("original");
  return (
    <div className="rs-root" data-testid="app-root">
      <div className="absolute right-4 top-4 z-10" data-testid="auth-corner">
        <Show when="signed-out">
          <SignInButton><button className="rs-bordered" data-testid="sign-in-btn">Sign In</button></SignInButton>
        </Show>
        <Show when="signed-in"><UserButton /></Show>
      </div>
      <div className="mx-auto flex min-h-[100dvh] max-w-[560px] flex-col justify-center gap-6 px-5 py-16">
        <Header />
        <Segment options={MODES} value={mode} onChange={setMode} testId="mode" />
        {mode !== "history" && <div className="flex items-center gap-3">
          <span className="rs-secondary shrink-0 text-[13px]">Quality</span>
          <Segment options={QUALITIES} value={quality} onChange={setQuality} testId="quality" className="flex-1" />
        </div>}
        {quality === "4k" && mode !== "history" && (
          <p className="rs-secondary -mt-3 text-[12px]" data-testid="quality-4k-note">
            Enlarges to 4K (2160p). Bigger files and slower; it can't add detail the original doesn't have.
          </p>
        )}
        {mode === "single" && <SingleCard quality={quality} />}
        {mode === "bulk" && <BulkCard quality={quality} />}
        {mode === "saved" && <SavedPanel quality={quality} />}
        {mode === "history" && <HistoryPanel />}
        {mode === "creators" && <CreatorsPanel quality={quality} />}
        <p className="rs-secondary text-center text-xs" data-testid="disclaimer">
          Use only for media you have permission to download.
        </p>
      </div>
    </div>
  );
}
